/*
 * @Author: Teemo Ding
 * @Date: 2021-04-15 16:46:12
 * @LastEditTime: 2021-10-09 16:04:05
 * @LastEditors: Teemo Ding
 * @Description: Carousel
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/Components/CarouselWithChebox/index.tsx
 */

import React from 'react';

import CheckImgDraggableDisplay from '@/src/components/CheckImgDraggableDisplay';
import AutoPlay from '@/src/constrains/SalesChannelPreviewPageComponents/AutoPlay';
import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import { EnumCarouselOptions } from '@/src/types/common/module';
import GeneralCollapseContent from 'src/constrains/SalesChannelPreviewPageComponents/GeneralCollapseContent';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const Carousel = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const posterTypeI18nMapping = {
    [EnumCarouselOptions.One]: 'general.one',
    [EnumCarouselOptions.Two]: 'general.two',
    [EnumCarouselOptions.Three]: 'general.three',
    [EnumCarouselOptions.Four]: 'general.four',
    [EnumCarouselOptions.Five]: 'general.five',
  };
  const {
    droppableId = 'carousel',
    draggableId,
    onItemDelete,
    onItemAdd,
    onItemChange,
    onItemSort,
    onStaticChange,
    data,
    hideAutoPlay,
    specificError,
    disabled,
  } = props;
  const { staticData, dynamicData: linkModules } = data;

  const { posterType, autoPlay, intervalTime } = staticData;
  const handleItemOnAdd = (e) => {
    if (onItemAdd) {
      onItemAdd(droppableId);
    }
  };

  const handleItemOnChange = (index, obj) => {
    console.log(index, obj);
    if (onItemChange) {
      onItemChange(draggableId, index, obj);
    }
  };

  const handleItemOnSort = (from, to) => {
    if (onItemSort) {
      onItemSort(draggableId, from, to);
    }
  };

  const handleOnItemDelete = (index) => {
    if (onItemDelete) {
      onItemDelete(draggableId, index);
    }
  };

  const handleAutoPlayOnChange = (e) => {
    if (onStaticChange) {
      onStaticChange(draggableId, { autoPlay: e });
    }
  };

  const handleIntervalOnChange = (e) => {
    if (onStaticChange) {
      onStaticChange(draggableId, { intervalTime: e });
    }
  };

  return (
    <GeneralCollapseContent>
      {!hideAutoPlay && (
        <Section bottomBorder>
          <ItemWrapper title={getI18n('general.type')}>
            {getI18n(posterTypeI18nMapping[posterType])}
          </ItemWrapper>
          <ItemWrapper>
            <AutoPlay
              interOnChange={handleIntervalOnChange}
              autoOnChange={handleAutoPlayOnChange}
              isAuto={autoPlay}
              interval={intervalTime}
              disabled={disabled}
            />
          </ItemWrapper>
        </Section>
      )}
      <CheckImgDraggableDisplay
        droppableId={droppableId}
        data={linkModules}
        addText={`+ ${getI18n('general.addImage')}`}
        onAdd={handleItemOnAdd}
        onChange={handleItemOnChange}
        onSort={handleItemOnSort}
        onDelete={linkModules.length == 1 ? null : handleOnItemDelete}
        specificError={specificError}
        disabled={disabled}
        hideAdd={disabled}
      />
    </GeneralCollapseContent>
  );
};

export default Carousel;
